import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { User } from './store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContextStatusType, UserContextService } from './services/user-context.service';
import { UserState } from './store/user-store/user.state';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild, OnDestroy {
  private authenticated = false;
  private readonly destroyed = new Subject();

  constructor(
    private readonly router: Router,
    private readonly store: Store,
    private readonly userContextService: UserContextService
  ) {
    this.store
      .select(UserState.getUserFromUserState)
      .pipe(takeUntil(this.destroyed))
      .subscribe((user: User) => {
        this.authenticated = user?.isAuthenticated;
      });
  }

  canActivateChild() {
    if (this.authenticated || this.hasAuthenticatedUserContext()) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }

  canActivate() {
    return this.canActivateChild();
  }

  ngOnDestroy(): void {
    this.destroyed.next('');
    this.destroyed.complete();
  }

  private hasAuthenticatedUserContext(): boolean {
    const tokenInfo = this.userContextService.getTokenInfo();
    const context = this.userContextService.getContext();

    return (
      Boolean(tokenInfo?.token) ||
      this.isLoggedInStatus(context?.session?.status) ||
      this.isLoggedInStatus(context?.global?.status)
    );
  }

  private isLoggedInStatus(status: ContextStatusType): boolean {
    return status === ContextStatusType.LOGGED_IN || status === ContextStatusType.LOGGED_IN_PENDING_REFRESH;
  }
}
